import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function usePresence(teamId: string | null, currentUserId: string | null) {
    const [onlineMemberIds, setOnlineMemberIds] = useState<string[]>([]);

    useEffect(() => {
        if (!teamId) {
            setOnlineMemberIds([]);
            return;
        }

        const channel = supabase.channel(`presence:${teamId}`, {
            config: {
                presence: {
                    key: currentUserId || 'anonymous',
                },
            },
        });

        channel
            .on('presence', { event: 'sync' }, () => {
                const state = channel.presenceState();
                const activeIds = Object.keys(state).filter(id => id !== 'anonymous');
                setOnlineMemberIds(activeIds);
            })
            .on('presence', { event: 'join' }, ({ key }) => {
                if (key && key !== 'anonymous') {
                    setOnlineMemberIds((prev) => Array.from(new Set([...prev, key])));
                }
            })
            .on('presence', { event: 'leave' }, ({ key }) => {
                if (key && key !== 'anonymous') {
                    // Check if there are other connections with the same key
                    const state = channel.presenceState();
                    if (!state[key] || state[key].length === 0) {
                        setOnlineMemberIds((prev) => prev.filter((id) => id !== key));
                    }
                }
            })
            .subscribe(async (status) => {
                if (status === 'SUBSCRIBED' && currentUserId) {
                    await channel.track({ online_at: new Date().toISOString() });
                }
            });

        return () => {
            channel.unsubscribe();
        };
    }, [teamId, currentUserId]);

    return { onlineMemberIds };
}
